import { Component, OnInit } from '@angular/core';
import { Contract, Data, Issue } from '@mlc/types';
import { EMPTY, switchMap } from 'rxjs';
import { IssuePositionLocked } from 'src/app/core/models/issuePositionLocked.model';
import { IssuesService } from 'src/app/core/services/issues/issues.service';
import { ContractService } from 'src/app/core/services/wallet/wallet.service';
import { ModalController } from '@ionic/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-issue-card',
  templateUrl: './issue-card.component.html',
  styleUrls: ['./issue-card.component.scss'],
  standalone: false
})
export class IssueCardComponent  implements OnInit {

  public issuePositionLocked!: IssuePositionLocked;
  public isModalOpen: boolean = false;
  public presentingElement!: HTMLElement | undefined;
  public contract!: Data<Contract>;
  public issue!: Data<Issue>;
  public busy: boolean = true;

  constructor(public contractService: ContractService, public issueService: IssuesService, public modalCtrl: ModalController) { }

  ngOnInit() {   
    this.presentingElement = document.querySelector('#main') as HTMLElement || undefined; 
    this.contractService.get()
    .pipe(
      switchMap((contract: Data<Contract> | undefined) => {
        if(!contract) return EMPTY;        
        this.contract = contract;        
        return this.issueService.loadIssues(contract.attributes.product.data.id);
      }),
      switchMap((issue: Data<Issue> | undefined) => {
        if(!issue) return EMPTY;
        this.issue = issue;
        return this.issueService.loadIssuePositionLocked(this.contract.id, issue?.id)
      }),
      untilDestroyed(this)
    )
    .subscribe((issuePositionLocked: IssuePositionLocked) => {      
      if(!issuePositionLocked) {
        this.busy = false;
        return;
      }
      this.busy = false;
      this.issuePositionLocked = issuePositionLocked;
    })
  }
}
